import React from 'react';

function HyperMinor(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <defs>
        <linearGradient x1="-1.11022302e-14%" y1="50%" x2="100%" y2="50%" id="linearGradient">
          <stop stopColor="#099FC3" offset="0%" />
          <stop stopColor="#8008F7" offset="50%" />
          <stop stopColor="#FF54B3" offset="100%" />
        </linearGradient>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-1968.000000, -1010.000000)">
          <g transform="translate(1912.000000, 962.000000)">
            <g>
              <g
                transform="translate(56.000000, 48.000000)"
                fill="url(#linearGradient)"
                fillRule="evenodd"
              >
                <path d="M10.8825263,6.36528947 C13.2726218,6.36528947 15.2172105,8.31022649 15.2172105,10.7010789 C15.2172105,13.0910344 13.2724136,15.0359474 10.8825263,15.0359474 C8.49167386,15.0359474 6.54655263,13.0911744 6.54655263,10.7010789 C6.54655263,10.3758486 6.80978231,10.1126842 7.13494737,10.1126842 C7.46026402,10.1126842 7.72352632,10.375816 7.72352632,10.7010789 C7.72352632,12.4425136 9.14067209,13.8591579 10.8825263,13.8591579 C12.6239223,13.8591579 14.0404211,12.4426034 14.0404211,10.7010789 C14.0404211,9.0194314 12.719758,7.64020908 11.0614495,7.54708988 L10.8825263,7.54207895 L7.13494737,7.54207895 C6.8098418,7.54207895 6.54655263,7.27878978 6.54655263,6.95368421 C6.54655263,6.66097693 6.75976867,6.41854302 7.03945721,6.37298331 L7.13494737,6.36528947 L10.8825263,6.36528947 Z M5.25986842,0.925 C7.65059975,0.925 9.59565789,2.86965179 9.59565789,5.25968421 C9.59565789,5.58497399 9.33255294,5.84807895 9.00726316,5.84807895 C8.68194651,5.84807895 8.41868421,5.58494714 8.41868421,5.25968421 C8.41868421,3.51837798 7.00148273,2.10178947 5.25986842,2.10178947 C3.5182797,2.10178947 2.10178947,3.51816827 2.10178947,5.25968421 C2.10178947,6.94135867 3.42247848,8.32055593 5.08092955,8.41367337 L5.25986842,8.41868421 L9.00726316,8.41868421 C9.33249346,8.41868421 9.59565789,8.68191389 9.59565789,9.00707895 C9.59565789,9.29986393 9.38252113,9.54238489 9.1027771,9.58796123 L9.00726316,9.59565789 L5.25986842,9.59565789 C2.86977293,9.59565789 0.925,7.65053666 0.925,5.25968421 C0.925,2.8697969 2.86991301,0.925 5.25986842,0.925 Z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HyperMinor;
